import { AvatarPadrao } from './AvatarPadrao'
export default AvatarPadrao;

export { AvatarPadrao, AvatarPadraoProps } from './AvatarPadrao';
